/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { CorporatePass, V2PaymentResponse } from "@api";

export class State {
  value?: V2PaymentResponse;
  corporatePass?: CorporatePass = {};
  currentTab: Tabs = Tabs.creditCard;
  fetching?: boolean;
  resetOnInit?: boolean = false;
  iframeUrl?: string;
  merchantReference?: string;
  sessionId?: string;
  result: any = [];
  clientSecret?: V2PaymentResponse['clientSecret']
}

export enum Tabs {
  creditCard,
  corporatePass,
  payLater,
  none
}
